import React from 'react';
import SweetLoadingSpinner from '../eyeCandy/SweetLoadingSpinner'
import ProjectList from './ProjectList';


class TrendingProjects extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            loading: true
        }
    }
    componentDidMount() {
        this.setState({
            loading: false
        });
    }
    render() {
        const { title, subtitle, ordering, limit, shuffle } = this.props;
        return(
            <div
                className="container"
                style={{
                    paddingTop: '50px',
                }}
            >
                <h5>{title || 'Recent Projects'}</h5>
                {subtitle && <p style={{fontStyle: 'italic', fontSize: '.85em'}}>{subtitle}</p>}
                <hr/>
                <SweetLoadingSpinner loadingState={this.state.loading} />
                <ProjectList publish={true} ordering={ordering} limit={limit} shuffle={shuffle} />
            </div>
        )
    }
}

export default TrendingProjects;